import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "switch-label-container"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 1,
  class: "switch-label-img-box"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 2,
  class: "switch-label-tag-box"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 0,
  class: "switch-label-content-wrapper"
};
import { ref, computed, onMounted } from 'vue';
import { Bridge } from '@/utils/bridge';
import { useLess } from '@/models/hooks';
import { useRoute } from 'vue-router';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
import { gatewayWidgetComponents } from '@/configs/views/landingPage.js';
export default {
  __name: 'SwitchLabel',
  props: {
    properties: {
      type: Object,
      require: true
    }
  },
  setup(__props) {
    const props = __props;
    useLess('views/landingPage/switchLabel/SwitchLabel.less');
    const route = useRoute();
    const FILL_TYPE = Object.freeze({
      PICURL: 'PICURL',
      SOLID_COLOR: 'SOLID_COLOR'
    });
    const LABEL_TYPE = Object.freeze({
      TEXT: 'TEXT',
      IMAGE: 'IMAGE'
    });
    const activeLable = ref(0);
    // Check if there is a tag corner in the listening label list. If it exists, it is true, otherwise it is false
    const cptIsCornerTagExist = computed(() => {
      return props.properties.switchLableList.some(item => item.subscriptUrl);
    });
    const filterComponent = categoryType => {
      var _gatewayWidgetCompone, _gatewayWidgetCompone2;
      return (_gatewayWidgetCompone = gatewayWidgetComponents.filter(componentItem => componentItem.type === categoryType)) === null || _gatewayWidgetCompone === void 0 ? void 0 : (_gatewayWidgetCompone2 = _gatewayWidgetCompone[0]) === null || _gatewayWidgetCompone2 === void 0 ? void 0 : _gatewayWidgetCompone2.component;
    };
    const onClickLabel = labelIndex => {
      activeLable.value = labelIndex;
    };
    onMounted(() => {
      const recordParams = {
        pageName: route.name
      };
      awsRumHandler.recordClickEvent({
        ...clickEvents.landingPage.switchLabelWidget,
        ...recordParams
      });
    });
    return (_ctx, _cache) => {
      var _props$properties$sw;
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass([{
          'switch-label-tabs-tag-wrapper': cptIsCornerTagExist.value
        }, 'switch-label-tabs-wrapper']),
        style: _normalizeStyle([__props.properties.fillType === _unref(FILL_TYPE).PICURL ? {
          backgroundImage: 'url(' + __props.properties.fillBackgroundColor + ')'
        } : {
          backgroundColor: __props.properties.fillBackgroundColor
        }, {
          marginBottom: __props.properties.bottomSpacing + 'px'
        }])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.properties.switchLableList, (labelItem, labelIndex) => {
        return _openBlock(), _createElementBlock("div", {
          key: labelIndex,
          class: _normalizeClass(['switch-label-area', {
            'switch-label-fixed-height': labelItem.labelType === _unref(LABEL_TYPE).TEXT
          }]),
          style: _normalizeStyle(activeLable.value === labelIndex ? {
            'background-color': __props.properties.backgroundSelectColor
          } : {
            'background-color': __props.properties.backgroundDefaultColor
          }),
          onClick: $event => onClickLabel(labelIndex)
        }, [labelItem.labelType === _unref(LABEL_TYPE).TEXT ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([{
            'switch-label-text-box-selected': activeLable.value === labelIndex
          }, 'switch-label-text-box']),
          style: _normalizeStyle(activeLable.value === labelIndex ? {
            color: __props.properties.textSelectColor
          } : {
            color: __props.properties.textDefaultColor
          })
        }, _toDisplayString(labelItem.labelName), 7)) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
          src: activeLable.value === labelIndex ? labelItem.selectedPicUrl : labelItem.notSelectedPicUrl,
          alt: ""
        }, null, 8, _hoisted_4)])), labelItem.subscriptUrl ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("img", {
          src: labelItem.subscriptUrl
        }, null, 8, _hoisted_6)])) : _createCommentVNode("", true)], 14, _hoisted_2);
      }), 128))], 6), (_props$properties$sw = __props.properties.switchLableList[activeLable.value].lableWidgets) !== null && _props$properties$sw !== void 0 && _props$properties$sw.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.properties.switchLableList[activeLable.value].lableWidgets, (labelListItem, labelListIndex) => {
        return _openBlock(), _createElementBlock("div", {
          class: "switch-label-content-area",
          key: labelListItem
        }, [(_openBlock(), _createBlock(_resolveDynamicComponent(filterComponent(__props.properties.switchLableList[activeLable.value].lableWidgets[labelListIndex].categoryType)), {
          properties: __props.properties.switchLableList[activeLable.value].lableWidgets[labelListIndex]
        }, null, 8, ["properties"]))]);
      }), 128))])) : _createCommentVNode("", true)])), [[_directive_loading, _ctx.loading]]);
    };
  }
};